module.exports = __webpack_public_path__ + "Icono_Status_512px.png";